import React, { useState } from "react";
import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { Button, Typography, Box, TextField } from "@mui/material";
import PropTypes from "prop-types";
import styles from "./CheckoutForm.module.css";

const CheckoutForm = ({ onPaymentSuccess, amount, emailNeeded, userEmail, onEmailChange }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [email, setEmail] = useState(userEmail || "");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    if (!stripe || !elements) return;

    const { error: stripeError } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        payment_method_data: {
          billing_details: {
            email,
          },
        },
      },
      redirect: "if_required",
    });

    if (stripeError) {
      setError(stripeError.message);
    } else {
      onPaymentSuccess();
    }

    setLoading(false);
  };


  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    if (onEmailChange) {
      onEmailChange(e.target.value);
    }
  };

  return (
    <form className={styles.checkoutForm} onSubmit={handleSubmit}>

      {emailNeeded && (
        <>
          <Typography className={styles.paymentTitle}>Enter email used to see memories you own</Typography>

          <TextField
              label="Email"
              type="email"
              value={email}
              onChange={handleEmailChange}
              required
              fullWidth
              margin="normal"
              variant="standard"
            />
        </>
      )}
      <Typography className={styles.paymentTitle}>Enter your payment details</Typography>

      <Box className={styles.cardElementWrapper}>
        <PaymentElement />
      </Box>

      {error && <Typography className={styles.errorMessage}>{error}</Typography>}

      <Button type="submit" className={styles.payButton} disabled={!stripe || loading}>
        {loading ? "Processing..." : `Pay ${amount}`}
      </Button>
    </form>
  );
};

CheckoutForm.propTypes = {
  onPaymentSuccess: PropTypes.func.isRequired,
  amount: PropTypes.string.isRequired,
  userEmail: PropTypes.string,
};

export default CheckoutForm;